<template>
    <div id="viewerheader" v-if="initWebtoonInfo !== null && initEpisodeState !== null">
        <div class="container">
            <router-link tag="h1" to="/" class="logo">artube</router-link>
            <p class="back-list" @click='backList'>{{initWebtoonInfo.titleName}}</p>
            <p>></p>
            <p>{{initEpisodeIdx}}화</p>
            <div class="level">
                <div class="prev" @click="prevEpisode" :class="[initEpisodeState.preEpisodeIdx === null ? 'none' : '']"></div>
                <div class="now">{{initEpisodeIdx}}화</div>
                <div class="next" @click="nextEpisode" :class="[initEpisodeState.nextEpisodeIdx === null ? 'none' : '']"></div>
            </div>
        </div>
        <Login :initIsShowPopup="isShowLoginPopup" @close="close('Login')" />
        <Buy  :initIsShowPopup="isShowBuyPopup" :initWebtoonInfo="initWebtoonInfo" :initEpisodeInfo="chagneEpisodeInfo" :initSiteConfig="siteConfig" @close="close('Buy')"  />
    </div>
</template>

<script>

import Buy from '@/components/Buy.vue'
import Login from '@/components/Login.vue'

export default {
    name: 'ViewerHeader',
    components: {
        Buy,
        Login,
    },
    data(){
        return {
            chagneEpisodeInfo: null,

            isShowLoginPopup: false,
            isShowBuyPopup: false,
        }
    },
    props: {
        initWebtoonInfo: {
            type: Object,
            default: null
        },
        initEpisodeIdx:{
            type: Number,
            default: 0,
        },
        initEpisodeState: {
            type: Object,
            default: null
        },
    },
    created() {
        this.mixinSiteConfigCheck();
    },
    mounted(){
    },
    beforeDestroy() {
	},
    methods: {
        closePopup(){
            this.$emit('close');
        },
        async prevEpisode(){
            if(this.initEpisodeState.preEpisodeIdx !== null){
                this.checkEpisodeState(this.initWebtoonInfo.webToonIndex, this.initEpisodeState.preEpisodeIdx);
            }
        },
        async nextEpisode(){
            if(this.initEpisodeState.nextEpisodeIdx !== null){
                this.checkEpisodeState(this.initWebtoonInfo.webToonIndex, this.initEpisodeState.nextEpisodeIdx)
            }
        },
        async checkEpisodeState(wtIdx, epIdx){
            var param = 
            {
                ticket: this.$store.state.ticket,
                sign: this.$store.state.sign,
                viewAdult: this.$store.state.isCheckedAdult ? 1 : 0,

                webtoonIdx: wtIdx,
                episodeIdx: epIdx,
                lang: 'KR'
            }
            await this.$Axios.post(`${this.host}/episode/state`, param, { headers: { 'Pragma' : 'no-cache', 'Cache-Control': 'no-cache', 'Access-Control-Allow-Origin': '*', 'Content-type': 'application/json', }}).then(async(res) => {
                // console.log('----episode state----');
                // console.log(res);

                if(res.data.epData != null){
                    this.chagneEpisodeInfo = res.data.epData;
                }

                if (res.data.returnCode === 0) {
                    this.$router.push('/Viewer/' + wtIdx + '/' + epIdx);
                }
                else if(res.data.returnCode === 503){   //로그인 필요
                    this.isShowLoginPopup = true;
                }
                else if(res.data.returnCode === 504){   //구매 필요
                    this.isShowBuyPopup = true;
                }
                else{
                    console.log(res.data.dsscription);
                }
            })
            .catch((error) => {
                console.log(error);
            });
        },
        backList(){
            this.$router.push('/Toondetail/' + this.initWebtoonInfo.webToonIndex);
        },
        close(popupType){
            switch(popupType){
                case 'Login':
                    this.isShowLoginPopup = false;
                    break;
                case 'Buy':
                    this.isShowBuyPopup = false;
                    break;
            }
        },
        
    },
}
</script>